module.exports = __webpack_public_path__ + "static/media/kanbanDNTidakDitemukan.566625f2.mp3";